'atumSupplier'.datatype({source: 'WC'})
'_code'.field()
'name'.field()
'_tax_number'.field()
'_phone'.field()
'_fax'.field()
'_general_email'.field()
'_ordering_email'.field()
'_website'.field()
'_ordering_url'.field()
'_description'.field()
'_address'.field()
'_city'.field()
'_state'.field()
'_zip_code'.field()
'_country'.field()
'_currency'.field()
'_tax_rate'.field({numeric: true})
'_discount'.field({numeric: true})
'_lead_time'.field({numeric: true})

'atumSupplier'.method('toSupplier', async function () {
  let res = await 'Supplier'.bringFirst({name: this.name})
  return res
})
